<template>
  <div class="footer">
    <div class="footer-text">
      <p>
        {{ footerData.filingInformation || "办学许可证号：豫教民4101000100004 备案号：豫ICP备2022003182号" }}
      </p>
      <p>{{ footerData.versionInformation || "CopyrightⒸ2004-2019.All Rights Reserved. 郑州健康学院 版权所有" }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    footerData: {
      type: Object,
      default: () => {}
    }
  },
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  height: 70px;
  background-color: #0E7328;
  .footer-text {
    width: 880px;
    height: 52px;
    margin:  auto;
    padding-top: 19px;
    font-size: 12px;
    text-align: center;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    // line-height: 20px;
  }
}

</style>